interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc: string;
  id?: string;
}

export default function SectionHeading({ eyebrow, title, desc, id }: SectionHeadingProps) {
  return (
    <div className="mb-8 md:mb-10">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700 uppercase tracking-wider">
        <i className="ri-flashlight-fill" />
        {eyebrow}
      </span>
      <h2 id={id} className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
        {title}
      </h2>
      <p className="mt-3 max-w-2xl text-sm md:text-base leading-6 text-foreground-600">{desc}</p>
    </div>
  );
}